import request from '@/utils/request'

export function listAct(data) {
  return request({
    url: '/api/v1/admin/act/list',
    method: 'post',
    data,
    mock: false,
  })
}

export function deleteAct(data) {
  return request({
    url: '/api/v1/admin/act/delete',
    method: 'post',
    data,
    mock: false,
  })
}
// /api/v1/admin/act/create
export function createAct(data) {
  return request({
    url: '/api/v1/admin/act/create',
    method: 'post',
    data,
    mock: false,
  })
}

///api/v1/admin/act/update
export function updateAct(data) {
  return request({
    url: '/api/v1/admin/act/update',
    method: 'post',
    data,
    mock: false,
  })
}

export function detailAct(data) {
  return request({
    url: '/api/v1/admin/act/detail',
    method: 'post',
    data,
    mock: false,
  })
}

export function getSpinLuckLog(data) {
  return request({
    url: '/api/v1/admin/act/spin_luck/log',
    method: 'post',
    data,
    mock: false,
  })
}
///api/v1/admin/act/sign_in/log
export function getSignInLog(data) {
  return request({
    url: '/api/v1/admin/act/sign_in/log',
    method: 'post',
    data,
    mock: false,
  })
}
///api/v1/admin/act/red_envelope_rain/log
export function getRedEnvelopeRainLog(data) {
  return request({
    url: '/api/v1/admin/act/gold_rain/log',
    method: 'post',
    data,
    mock: false,
  })
}
